import React from "react";
import "./Project.css";
import {FaGithub} from 'react-icons/fa'
import {FiExternalLink} from 'react-icons/fi'
const ProjectSection = () => {
  const projectData = [
    {
      id: 1,
      name:    'OUR BAKERY ECOMMERCE WEB-APP',
      image: './Images/img-1.jpg',
      description: 'Our Bakery websit is an ecommerce web-app with multiple pages where you can buy online with multiple feature like add to cart, increment, decrement and remove products pagination and product category.',
      skill: 'React JS',
      skill3: 'CSS',
      demo: 'https://our-bakery.netlify.app/',
      code: 'https://github.com/Bilal7659/an-ecommerce-webapp',

    },
    {
      id: 2,
      name: 'Todo table App',
      image: './Images/Capture.PNG',
      description: ' A Todo table app is a simple react ant desigen app which show user information todo table uses Crud operation and Pagination.',
      skill: 'React',
      skill2: 'Antd',
      demo: 'https://todo-table-react-app.netlify.app/',
      code: 'https://github.com/Bilal7659/Todo-app',

    },
    {
      id: 3,
      name: 'Admain-Dashboard',
      image: './Images/admain-dashbord.PNG',
      description: 'Admain dashbord show the the information about Sells, Customer, Revenue, Inventory, Orders and a cheat sheet which show the sell product also comments of customer and notification of product when it is selled all the data came from an API.',
      skill: 'React',
      skill2: 'Antd',
      skill3: 'Api',
      demo: 'https://react-admain-dashboard.netlify.app/',
      code: 'https://github.com/Bilal7659/admain-dashboard',


    },
    {
      id: 4,
      name: 'PakVisit',
      image: './Images/Naran.jpg',
      description: ' A Pak visit is a tourist landing page website that allow users to see  our tourist places that where we want to go PakVisit allow user to see our tour places and Book tours.',
      skill: 'CSS',
      skill2: 'React',
      demo: 'https://pakvisit-travel-web-app.netlify.app/',
      code: 'https://github.com/Bilal7659/travel-react-app',


    },
  ]
  return (
    <section id="project" className="project">
      {/* <div className="container"> */}
      <div className="project">
        {projectData.map(item=>(
                   <div className="project-one">
                   <div className="image-s">
                     <img src={item.image} alt="" />
                   </div>
                   <div className="text-s">
                     <div className="text-one">
                       <h3>{item.name} </h3>
                       <p>{item.description} </p>
                     </div>
                     <div className="skill-s">
                       <p>{item.skill}</p>
                       {item.skill2 && <p>{item.skill2}</p>}
                      {item.skill3 && <p>{item.skill3}</p>}
                     </div>
                     <div className="social-link">
                           <div className="social-one">
                             <p>Code</p>
                            <a href={item.code} target='_blank'><FaGithub style={{fontSize:'2rem'}}/></a>
                           </div>
                           <div className="social-one">
                           <p>Live Demo</p>
                             <a href={item.demo} target="-blank">< FiExternalLink style={{fontSize:'2rem'}}/></a>
                           </div>
                           </div>
                         </div>
                   </div>
        ))}
       </div>
      {/* </div> */}
      {/* </div> */}
    </section>
  );
};

export default ProjectSection;
